module.exports = __webpack_public_path__ + "img/web-security.b360a3b.svg";